import emailjs from "@emailjs/browser";

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL;
const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || "Sky High NTB";
const BASE_URL = process.env.REACT_APP_BASE_URL || "https://skyhighntb.com";

const generateTradeStartSupportNotificationHTML = (data) => {
  const adminLink = `${BASE_URL}/userdetail/${data.userId}`;
  const amount = typeof data.amount === 'number' ? data.amount.toFixed(2) : data.amount;

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        .header { background: linear-gradient(to right, #8b0000, #dc143c); color: #ffffff; padding: 20px; text-align: center; border-radius: 10px 10px 0 0; }
        .content { padding: 10px; color: #333; }
        .info-box { background: #f8f9fa; padding: 20px; border-radius: 8px; margin: 20px 0; }
        .info-box p { margin: 12px 0; }
        .label { font-weight: bold; color: #2C3D4F; }
        .btn { display: inline-block; padding: 12px 30px; background: #8b0000; color: gold; text-decoration: none; border-radius: 5px; margin: 20px 0; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>New Trade Started</h1>
        </div>
        <div class="content">
          <p>A new trade has been started on ${BRAND_NAME}.</p>

          <div class="info-box">
            <p><span class="label">User:</span> ${data.userName}</p>
            <p><span class="label">Email:</span> ${data.userEmail}</p>
            <p><span class="label">Plan:</span> ${data.planName}</p>
            <p><span class="label">Amount:</span> $${amount}</p>
            <p><span class="label">Duration:</span> ${data.duration} days</p>
            <p><span class="label">Date:</span> ${data.date}</p>
            <p><span class="label">Transaction Type:</span> Debit</p>
            <p><span class="label">Account:</span> Investments</p>
          </div>

          <div style="text-align: center;">
            <a href="${adminLink}" class="btn">View User</a>
          </div>
        </div>
      </div>
    </body>
    </html>
  `;
};

const generateTradeStartConfirmationHTML = (data) => {
  const transactionsLink = `${BASE_URL}/fxt/transactions`;
  const amount = typeof data.amount === 'number' ? data.amount.toFixed(2) : data.amount;

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        .header { background: linear-gradient(to right, #8b0000, #dc143c); color: #ffffff; padding: 20px; text-align: center; border-radius: 10px 10px 0 0; }
        .content { padding: 10px; color: #333; }
        .info-box { background: #f8f9fa; padding: 20px; border-radius: 8px; margin: 20px 0; }
        .info-box p { margin: 12px 0; }
        .label { font-weight: bold; color: #2C3D4F; }
        .amount { font-size: 28px; font-weight: bold; color: #8b0000; }
        .btn { display: inline-block; padding: 12px 30px; background: #8b0000; color: gold; text-decoration: none; border-radius: 5px; margin: 20px 0; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>Trade Started Successfully</h1>
        </div>
        <div class="content">
          <p>Hello <strong>${data.userName}</strong>,</p>
          <p>Your investment plan has been activated and is now running!</p>

          <div class="info-box">
            <p><span class="label">Plan:</span> ${data.planName}</p>
            <p><span class="label">Amount Invested:</span> <span class="amount">$${amount}</span></p>
            <p><span class="label">Duration:</span> ${data.duration} days</p>
            <p><span class="label">Start Date:</span> ${data.date}</p>
            <p><span class="label">End Date:</span> ${data.endDate}</p>
            <p><span class="label">Transaction Type:</span> Debit</p>
            <p><span class="label">Account:</span> Investments</p>
          </div>

          <p>You will receive a notification when your trade is completed and ready to claim.</p>

          <div style="text-align: center;">
            <a href="${transactionsLink}" class="btn">View Transactions</a>
          </div>
        </div>
      </div>
    </body>
    </html>
  `;
};

export const sendTradeStartNotificationToSupport = async (data) => {
  console.log("Sending trade start notification to support...", { SUPPORT_EMAIL, data });
  try {
    const html = generateTradeStartSupportNotificationHTML(data);
    const response = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      {
        user_name: "Admin",
        user_email: SUPPORT_EMAIL,
        html: html,
      },
      PUBLIC_KEY
    );
    console.log("Trade start notification sent:", response);
    return true;
  } catch (error) {
    console.error("Error sending trade start notification:", error);
    return false;
  }
};

export const sendTradeStartConfirmationToUser = async (userEmail, data) => {
  console.log("Sending trade start confirmation to user...", { userEmail, data });
  try {
    const html = generateTradeStartConfirmationHTML(data);
    const response = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      {
        user_name: data.userName,
        user_email: userEmail,
        html: html,
      },
      PUBLIC_KEY
    );
    console.log("Trade start confirmation sent:", response);
    return true;
  } catch (error) {
    console.error("Error sending trade start confirmation:", error);
    return false;
  }
};

export const sendTradeStartEmails = async (userEmail, data) => {
  const supportResult = await sendTradeStartNotificationToSupport(data);
  const userResult = await sendTradeStartConfirmationToUser(userEmail, data);
  return supportResult && userResult;
};

const generateTradeClaimSupportNotificationHTML = (data) => {
  const adminLink = `${BASE_URL}/userdetail/${data.userId}`;
  const amount = typeof data.amount === 'number' ? data.amount.toFixed(2) : data.amount;

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        .header { background: linear-gradient(to right, #8b0000, #dc143c); color: #ffffff; padding: 20px; text-align: center; border-radius: 10px 10px 0 0; }
        .content { padding: 10px; color: #333; }
        .info-box { background: #f8f9fa; padding: 20px; border-radius: 8px; margin: 20px 0; }
        .info-box p { margin: 12px 0; }
        .label { font-weight: bold; color: #2C3D4F; }
        .btn { display: inline-block; padding: 12px 30px; background: #8b0000; color: gold; text-decoration: none; border-radius: 5px; margin: 20px 0; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>Trade Claim Completed</h1>
        </div>
        <div class="content">
          <p>A trade claim has been completed on ${BRAND_NAME}.</p>

          <div class="info-box">
            <p><span class="label">User:</span> ${data.userName}</p>
            <p><span class="label">Email:</span> ${data.userEmail}</p>
            <p><span class="label">Plan:</span> ${data.planName}</p>
            <p><span class="label">Amount:</span> $${amount}</p>
            <p><span class="label">Date:</span> ${data.date}</p>
            <p><span class="label">Transaction Type:</span> Credit</p>
            <p><span class="label">Status:</span> ${data.status}</p>
          </div>

          <div style="text-align: center;">
            <a href="${adminLink}" class="btn">View User</a>
          </div>
        </div>
      </div>
    </body>
    </html>
  `;
};

const generateTradeClaimConfirmationHTML = (data) => {
  const transactionsLink = `${BASE_URL}/fxt/transactions`;
  const amount = typeof data.amount === 'number' ? data.amount.toFixed(2) : data.amount;

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        .header { background: linear-gradient(to right, #8b0000, #dc143c); color: #ffffff; padding: 20px; text-align: center; border-radius: 10px 10px 0 0; }
        .content { padding: 10px; color: #333; }
        .info-box { background: #f8f9fa; padding: 20px; border-radius: 8px; margin: 20px 0; }
        .info-box p { margin: 12px 0; }
        .label { font-weight: bold; color: #2C3D4F; }
        .amount { font-size: 28px; font-weight: bold; color: #8b0000; }
        .btn { display: inline-block; padding: 12px 30px; background: #8b0000; color: gold; text-decoration: none; border-radius: 5px; margin: 20px 0; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>Trade Claim Successful</h1>
        </div>
        <div class="content">
          <p>Hello <strong>${data.userName}</strong>,</p>
          <p>Your investment plan has been completed and your earnings have been credited!</p>

          <div class="info-box">
            <p><span class="label">Plan:</span> ${data.planName}</p>
            <p><span class="label">Amount Credited:</span> <span class="amount">$${amount}</span></p>
            <p><span class="label">Date:</span> ${data.date}</p>
            <p><span class="label">Transaction Type:</span> Credit</p>
            <p><span class="label">Status:</span> ${data.status}</p>
          </div>

          <div style="text-align: center;">
            <a href="${transactionsLink}" class="btn">View Transactions</a>
          </div>
        </div>
      </div>
    </body>
    </html>
  `;
};

export const sendTradeClaimNotificationToSupport = async (data) => {
  console.log("Sending trade claim notification to support...", { SUPPORT_EMAIL, data });
  try {
    const html = generateTradeClaimSupportNotificationHTML(data);
    const response = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      {
        user_name: "Admin",
        user_email: SUPPORT_EMAIL,
        html: html,
      },
      PUBLIC_KEY
    );
    console.log("Trade claim notification sent:", response);
    return true;
  } catch (error) {
    console.error("Error sending trade claim notification:", error);
    return false;
  }
};

export const sendTradeClaimConfirmationToUser = async (userEmail, data) => {
  console.log("Sending trade claim confirmation to user...", { userEmail, data });
  try {
    const html = generateTradeClaimConfirmationHTML(data);
    const response = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      {
        user_name: data.userName,
        user_email: userEmail,
        html: html,
      },
      PUBLIC_KEY
    );
    console.log("Trade claim confirmation sent:", response);
    return true;
  } catch (error) {
    console.error("Error sending trade claim confirmation:", error);
    return false;
  }
};

export const sendTradeClaimEmails = async (userEmail, data) => {
  const supportResult = await sendTradeClaimNotificationToSupport(data);
  const userResult = await sendTradeClaimConfirmationToUser(userEmail, data);
  return supportResult && userResult;
};